<forge-text-field [invalid]="isInvalid" [required]="isRequired">
  <textarea #input type="text" [formControl]="formControl" [rows]="rows" autocomplete="off"></textarea>

  @if (!hideLabel) {
    <label slot="label">{{label}}</label>
  }

  @if (showMaxLengthHint) {
    <span slot="support-text-end">
      {{length}}/{{maxLength}}
    </span>
  }

  <span slot="support-text">
    @if (hasError('required')) {
      {{label}} is required
    }

    @if (hasError('minlength')) {
      {{label}} must be at least {{minLength}} characters long
    }

    @if (hasError('maxlength')) {
      {{label}} cannot be longer than {{maxLength}} characters
    }

    @if (hasCustomValidators) {
      @for (customError of customErrors; track customError) {
        @if (hasError(customError.errorKey)) {
          {{customError.message}}
        }
      }
    }
  </span>
  @if (tooltip) {
    <forge-tooltip>{{tooltip}}</forge-tooltip>
  }
</forge-text-field>